const backgroundColors = {
  primary: '#292929',
  primaryBrand: '#FFFFFF',
};

export default backgroundColors;
